/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OrgCapabilitiesRollout { 
    /**
     * Tenant visible rollout types comma separated.
     */
    tenant_visible_rollout_types?: string;
    /**
     * Tenant target reschedule allowed rollout types comma separated.
     */
    tenant_target_reschedule_allowed_rollout_types?: string;
}

